import React from 'react';

const SquareButton = ({ color, active, onChange }) => (
    <div
        onClick={() => onChange(color)}
        style={{
            boxShadow: `#${color} 0px 0px 0px 14px inset`
        }}
        className={`square-picker-button${active ? ' square-picker-button-active' : ''}`}
    />
);

const SquarePicker = ({ colors, color, onChange }) => (
    <div className="square-picker">
        {colors.map(c => (
            <SquareButton key={c} active={c === color} color={c} onChange={onChange} />
        ))}
    </div>
);

export default SquarePicker;
